import {asyncPost, asyncLoad} from '.';
import {formValidation, handleError} from '../helpers';
import {ProcessorNames, ProcessorTypes} from '../helpers/constants';

export const getPayPalCurrencies = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Currencies',
    url: '/CurrencyCodes/PayPal',
    params: {includePortal: false},
  });

export const getPaymentProcessors = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Payment Processors',
    url: '/payment-processors',
  });

export const getProcessorSettings = processor => dispatch =>
  asyncLoad({
    dispatch,
    title: `Processor Settings for ${processor}`,
    url: `/payment-processors/${processor.toLowerCase()}`,
  });

export const getWePayRegistration = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'mHelpDesk Payments settings',
    url: '/wePay/registration',
  });

export const reenableWePay = () => dispatch =>
  asyncPost({
    url: '/wePay/isEnabled',
    dispatch,
    title: 'mHelpDesk Payments settings',
    params: {method: 'PUT'},
    body: {value: true},
    successMessage: 'mHelpDesk Payments enabled',
  });

export const saveProcessorSettings = (processor, settings) => dispatch => {
  const formObject = formValidation.setupFormBody(settings, false);
  if (formObject.hasError) {
    handleError(formObject.errorMessage, null, dispatch);
    return false;
  }

  const isWePay =
    processor.toLowerCase() === ProcessorTypes.WePay.toLowerCase();

  return asyncPost({
    url: isWePay ? '/wePay/registration' : `/payment-processors/${processor}`,
    dispatch,
    title: `Processor Settings for ${ProcessorNames[processor.toLowerCase()]}`,
    params: {method: isWePay ? 'POST' : 'PUT'},
    body: {...formObject.body, enabled: true},
    successMessage: `${
      ProcessorNames[processor.toLowerCase()]
    } settings saved!`,
  });
};

export const disableProcessor = processor => dispatch => {
  let url = `/payment-processors/${processor}`;
  let body;
  switch (processor) {
    case ProcessorTypes.Stripe:
      body = {
        publicKey: '',
      };
      break;

    case ProcessorTypes.Auth:
      body = {
        allowAmericanExpress: true,
        allowDiscover: true,
        allowMasterCard: true,
        allowVisa: true,
        apiLogin: '',
        publicKey: '',
        authorizationKey: '',
      };
      break;

    case ProcessorTypes.PayPal:
      body = {
        email: '',
        currency: '',
      };
      break;

    case ProcessorTypes.WePay:
      url = '/wePay/isEnabled';
      body = {value: false};
      break;
  }

  return asyncPost({
    url,
    dispatch,
    title: `Processor Settings for ${ProcessorNames[processor.toLowerCase()]}`,
    params: {method: 'PUT'},
    body: {...body, enabled: false},
    successMessage: `${ProcessorNames[processor.toLowerCase()]} disabled`,
  });
};

export const stripeCallback = body => async dispatch =>
  await asyncPost({
    body,
    dispatch,
    successMessage: 'You are now connected to Stripe.',
    title: 'Connection to Stripe',
    url: '/payment-processors/connect/stripe',
  });

export const squareSignup = () => async dispatch =>
  await asyncPost({
    dispatch,
    title: 'Square Initialization',
    url: '/payment-processors/square/signup',
  });

export const squareCallback = (code, stateToken) => dispatch => {
  return asyncPost({
    body: {code, stateToken, enabled: true},
    dispatch,
    params: {method: 'PUT'},
    successMessage: 'You are now connected to Square!',
    title: 'Connection to Square',
    url: '/payment-processors/square',
  });
};

export const loadSquareLocations = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Square locations',
    url: '/payment-processors/square/locations',
  });



// WEBPACK FOOTER //
// ./src/actions/processorActions.js